var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("pre", {
    directives: [
      {
        name: "safe-html",
        rawName: "v-safe-html",
        value: _vm.formattedTicket,
        expression: "formattedTicket",
      },
    ],
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }